import { Observable, Subject } from 'rxjs';

export class ShuiModalRef<TResult = unknown> {
    private readonly _afterClosed = new Subject<TResult | undefined>();

    public readonly afterClosed: Observable<TResult | undefined> = this._afterClosed.asObservable();

    public close(result?: TResult): void {
        this._afterClosed.next(result);
        this._afterClosed.complete();
    }
}
